import { BaseEditorExtension, emojiExtension } from '../chunk-KQ45IS4N.js';
import '../chunk-U67V476Y.js';
import { generateJSON, generateHTML } from '@tiptap/html';

var parseHtmlToJson = generateJSON;
var parseJsonToHtml = generateHTML;
var parseHtmlToPlainText = (content) => {
  const def = generateJSON(content, [
    BaseEditorExtension.configure(),
    emojiExtension
  ]);
  return nodeToPlainText(def);
};
var nodeToPlainText = (node) => {
  var _a, _b;
  if (!node) {
    return "";
  }
  if ("text" in node) {
    return ((_a = node.text) == null ? void 0 : _a.trim()) ?? "";
  }
  if (node.type === "emoji-search") {
    return `:${node.attrs.id || "emoji"}:`;
  }
  if ("content" in node && node.content)
    return ((_b = node.content) == null ? void 0 : _b.map((i) => nodeToPlainText(i)).join(" ")) ?? "";
  return "";
};

export { parseHtmlToJson, parseHtmlToPlainText, parseJsonToHtml };
